export default function (context, inject) {
  const config = {
  "metadatas": {
    "name": "95 Décibels",
    "webappThemeColor": "#e85512",
    "lang": "fr-FR",
    "charset": "utf-8",
    "colorPrimary": "#e85512",
    "colorAccent": "#ededed",
    "colorSecondary": "#ff8f00",
    "colorInfo": "#26a69a",
    "colorWarning": "#ffc107",
    "colorError": "#dd2c00",
    "colorSuccess": "#00e676",
    "iconFileName": "icon.png",
    "iconProperties": {},
    "supportEmailAddress": "digital@mediameeting.fr",
    "siteHeadTitle": "95 Décibels",
    "appName": "95 Décibels",
    "webappFonts": {
      "google": {
        "families": [
          "Roboto:300,400,500,700",
          "Merriweather:300,400,500,700",
          "Material+Icons"
        ],
        "downloadFonts": true
      }
    }
  }
}
  const metadatas = config.metadatas

  inject('metadatas', config.metadatas)
}
